export default __webpack_public_path__ + "static/media/stellar_care.97480136.jpg";